import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    container: {
        display: "flex",
        flexDirection: "column",
        alignItems: 'center',
        backgroundColor: theme.palette.common.white,
        flexGrow: 1,
        justifyContent: 'center',
        height: 'calc(100vh - 250px)'
    }
}));

export {useStyles}